// Verifica si el usuario NO está en la página de checkout
//if (window.location.pathname.startsWith("/account") || /^\d/.test(window.location.pathname) || window.location.pathname.startsWith("/checkouts")) {
  //console.log("trigger NO REDIRECT");
//} else {
//  window.location.href = "https://elitebienetre.fr/cart/";
//}
if (
  window.location.pathname.startsWith("/account") ||
  /^\d/.test(window.location.pathname) ||
  window.location.pathname.startsWith("/checkouts")||
  window.location.pathname.startsWith("/pages/me-retracter-du-contrat-ici")
) {
  // No redirigir en estas páginas
} else {
  const currentPath = window.location.pathname + window.location.search + window.location.hash;
  const newUrl = `https://elitebienetre.fr${currentPath}`;
  window.location.href = newUrl;
}
